<div class="install-banner">
  <button
    type="button"
    class="install-banner__close"
    aria-label="بستن"
    (click)="close($event)"
  >
    <i class="icon-x-close"></i>
  </button>

  <img
    class="install-banner__icon"
    src="icons/icon-192x192.png"
    width="24"
    height="24"
    alt=""
  />

  <div class="install-banner__body">
    <strong>نصب باکارت</strong>
    <p>برای دسترسی سریع‌تر نصب کنید.</p>
    <button
      type="button"
      nttLinkButton
      size="tiny"
      class="install-banner__action"
      (click)="pwa.install()"
    >
      نصب اپلیکیشن
    </button>
  </div>
</div>
